import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const KeepsakeVisual = ({ revealMeta = {} }) => (
  <span
    className={`lumirae-layer-visual lumirae-layer-visual-keepsake${revealMeta.isFinalLayer ? ' is-final-layer' : ''}`}
    aria-hidden="true"
  >
    <span className="closing-glow" />
    <span className="card lumirae-keepsake-card-capture">
      <span className="card-kicker">A gift for</span>
      <strong className="card-name">{revealMeta.recipientName || 'You'}</strong>
      <span className="qr-mark">
        {revealMeta.shareUrl ? (
          <QRCodeSVG value={revealMeta.shareUrl} size={42} level="M" />
        ) : (
          Array.from({ length: 9 }, (_, index) => (
            <i key={index} />
          ))
        )}
      </span>
      <small className="link-mark">{revealMeta.shortLinkLabel || 'copy link'}</small>
    </span>
    <span className="foil" />
    <span className="save-copy-hint">
      <b>Save Card</b>
      <b>Copy Link</b>
    </span>
  </span>
);

export default KeepsakeVisual;
